<template>
  <div class="material">
    <div class="material-fun">
      <a-input-search v-model:value="materialName"
                      :placeholder="$t('CustomSpus.MaterialLibraryPages.enterKeyword')"
                      class="material-search"
                      @search="onSearchName" />
      <a-popover v-model:visible="visible"
                 trigger="click"
                 placement="bottomLeft">
        <template #content>
          <div class="tag-content">
            <div v-for="tag in tagList"
                 :key="tag.id"
                 class="tag-content-box"
                 :class="selectId.includes(tag.key) ? 'selected-tag' : ''"
                 @click="selectTag(tag)">{{ tag.name }}
              <div v-show="selectId.includes(tag.key)"
                   class="tag-icon"></div>
            </div>
          </div>
          <div class="tag-footer">
            <a-button class="cancel-btn"
                      @click="cancel">{{ $t('CustomSpus.MaterialLibraryPages.cancel') }}</a-button>
            <a-button type="primary"
                      class="confirm-btn"
                      @click="confirm">{{ $t('CustomSpus.MaterialLibraryPages.confirm') }}</a-button>
          </div>
        </template>
        <div class="material-box">
          <MenuOutlined class="material-icon" />
        </div>
      </a-popover>
    </div>
    <div>
      <div v-for="(tag, index) in searchTag"
           :key="index"
           class="search-tag">
        {{ tag }}
      </div>
    </div>
    <div class="material-content">
      <ul class="material-list">
        <li v-for="(item, index) in materialList"
            :key="index"
            class="material-item"
            @click="addImage(item.image)">
          <a-popover trigger="hover"
                     :mouse-enter-delay='1'
                     placement="left"
                     :get-popup-container="(triggerNode: any) => { return triggerNode.parentNode }">
            <template #content>
              <div class="image-content">
                <img class="image-content-img"
                     :src="toUrl(item.image)" />
                <div class="image-content-name">{{ item.name }}</div>
                <div class="image-content-tagbox">
                  <div v-for="(tag, index) in item.tag?.split(',')"
                       :key="index"
                       class="image-content-tag">
                    <span v-for="item in tagList"
                          :key="item.id">
                      <span v-if="tag == item.key">{{ item.name }}</span>
                    </span>
                  </div>
                </div>
              </div>
            </template>
            <img class="material-img"
                 :src="toUrl(item.image)" />
          </a-popover>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { getMaterialList, fetchMaterialTag } from '../../api/index'
import { toUrl } from '@/utils'
import type { MaterialItem } from '../../types'
export interface Props {
  /**
   *组件显示隐藏
   */
  modelValue: string
}
const visible = ref<boolean>(false)
const materialList = ref<MaterialItem[]>([])
const tagList = ref<any[]>([])
const materialName = ref<string>('')
onMounted(async () => {
  await getMaterialList().then((result: any) => {
    materialList.value = result
  })
  await fetchMaterialTag().then(result => {
    tagList.value = result.data.items
  })
})
const onSearchName = () => {
  const data = {
    name: materialName.value
  }
  getMaterialList(data).then((result: any) => {
    materialList.value = result
  })
}
const selectId = ref<number[]>([])
const selectTag = (item: any) => {
  if (selectId.value.includes(item.key)) {
    selectId.value = selectId.value.filter(el => el != item.key)
  } else {
    selectId.value.push(item.key)
  }
}
withDefaults(defineProps<Props>(), {
  /**
   *衣服颜色
   */
  modelValue: 'shop',
})
const emit = defineEmits(['update:modelValue', 'changes'])

const addImage = (imageUrl: string) => {
  const imageTransformUrl = toUrl(imageUrl)
  emit('changes', imageTransformUrl)
}
const searchTag = ref<string[]>([])
const confirm = async () => {
  const data = {
    name: materialName.value,
    tag: selectId.value.join(',')
  }
  searchTag.value = []
  await getMaterialList(data).then((result: any) => {
    materialList.value = result
    tagList.value.forEach((tag) => {
      if (selectId.value?.includes(tag.key)) {
        searchTag.value.push(tag.name)
      }
    })
    visible.value = false
  })

}
const cancel = async () => {
  selectId.value = []
  const data = {
    name: materialName.value,
    tag: ''
  }
  await getMaterialList(data).then((result: any) => {
    materialList.value = result
    searchTag.value = []
    visible.value = false
  })
}
</script>
<style scoped lang="less">
.material {
  width: 300px;
  flex: 1;
  background-color: white;
  padding: 20px;
  display: flex;
  flex-flow: column;
  overflow: hidden;

  :deep(.ant-popover-inner-content) {
    padding: 0 !important;
  }

  .search-tag {
    display: inline-block;
    width: fit-content;
    min-width: 68px;
    height: 24px;
    line-height: 24px;
    background: #F6F6F6;
    padding: 0 5px;
    font-size: 14px;
    color: #999;
    text-align: center;
    margin: 0 6px 10px 0;
  }

  .material-fun {
    display: flex;
    justify-content: space-around;

    .material-search {
      flex: 1;
      margin-bottom: 10px;

      :deep(.ant-input) {
        height: 32px;
      }

      :deep(.ant-btn) {
        height: 30px;
        box-sizing: content-box;
        border: 1px solid #ccc;
        background: #f6f6f6;
      }
    }

    .material-box {
      flex: 1;
      max-width: 32px;
      max-height: 32px;
      line-height: 32px;
      text-align: center;
      display: inline-block;
      border: 1px solid #ccc;
      background: #f6f6f6;
      margin-left: 12px;
      cursor: pointer;

      .material-icon {
        font-size: 18px;
        color: #999;
      }
    }
  }

  .material-content {
    flex: 1;
    overflow: auto;
    scrollbar-width: thin;
    /* Firefox */
    scrollbar-color: transparent transparent;
    /* Firefox */

    .material-list {
      display: flex;
      flex-wrap: wrap;
      width: 100%;

      .material-item {
        background-color: #F6F6F6;
        width: 80px;
        height: 80px;
        margin-right: 10px;
        margin-bottom: 10px;
        cursor: pointer;

        .material-img {
          width: 80px;
          height: 80px;
        }
      }

      .material-item:nth-child(3n) {
        margin-right: 0px !important;
      }
    }
  }

  .material-content::-webkit-scrollbar {
    width: 0;
  }
}

.tag-content {
  width: 510px;
  padding: 8px 4px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-between;

  .tag-content-box {
    position: relative;
    width: 90px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    border: 1px solid #F1F1F1;
    font-size: 14px;
    cursor: pointer;
    margin-bottom: 10px;

    .tag-icon {
      position: absolute;
      bottom: 0;
      right: 0;
      width: 18px;
      height: 18px;
      background: url('../../icon/ic_subscript.png');
    }
  }

  .selected-tag {
    border: 1px solid #111111;
  }
}

.tag-footer {
  padding: 8px 4px;
  text-align: right;

  .cancel-btn {
    background-color: #f6f6f6;
    width: 98px;
    height: 40px;
    margin-right: 10px;
  }

  .confirm-btn {
    width: 98px;
    height: 40px;
  }
}

.image-content {
  width: 255px;
  height: 100%;
  padding-bottom: 10px;

  .image-content-img {
    width: 255px;
    height: 256px;
    background: #f6f6f6;
  }

  .image-content-name {
    margin: 10px 20px;
    word-wrap: break-word;
  }

  .image-content-tagbox {
    display: flex;
    flex-wrap: wrap;
    margin-left: 20px;

    .image-content-tag {
      min-width: 68px;
      height: 24px;
      line-height: 24px;
      background: #F6F6F6;
      padding: 0 5px;
      font-size: 14px;
      color: #999;
      text-align: center;
      margin: 0 6px 6px 0;
    }
  }

}
</style>
